import React from 'react';
import { ChevronDown, ChevronRight, MapPin, Calendar, Search } from 'lucide-react';

/**
 * MOCKUP statique — version MOBILE de la page publique de diffusion.
 * Variante : Cat / Block / Row / Pack tout sur une ligne par billet.
 */
const MobileMockupDemo = () => {
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center py-8 px-4" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div className="relative bg-black rounded-[3rem] p-3 shadow-2xl ring-2 ring-zinc-800" style={{ width: 390, maxWidth: '100%' }}>
        <div className="h-7 flex justify-center items-center">
          <div className="bg-zinc-900 rounded-full w-32 h-5" />
        </div>

        <div className="bg-zinc-950 rounded-[2.5rem] overflow-hidden text-white border border-zinc-800" style={{ minHeight: 780 }}>
          {/* HERO compact */}
          <div className="relative px-4 pt-5 pb-4 border-b border-zinc-800/80" style={{ background: 'linear-gradient(135deg, rgba(196,160,82,0.18), rgba(9,9,11,0.95))' }}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-2.5">
                <img
                  src="https://customer-assets.emergentagent.com/job_289d1ff2-678c-4880-b158-8ad7c1edcdb9/artifacts/3lgyi1im_hero-adidas-trionda-fifa-worldcup-ball6-1400x788%20%281%29.webp"
                  alt="FIFA"
                  className="h-12 w-12 object-contain rounded-xl ring-1 ring-amber-500/30 bg-black/40 p-1"
                />
                <div>
                  <div className="text-base font-bold tracking-tight">FIFA World Cup 2026</div>
                  <div className="text-[11px] text-zinc-400">
                    <span className="text-amber-400 font-bold">34</span> tickets · <span className="text-amber-400 font-bold">12</span> matches
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 bg-zinc-900/80 border border-zinc-700 rounded-full p-0.5">
                <button className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-500 text-zinc-950">EN</button>
                <button className="px-2 py-0.5 rounded-full text-[10px] font-bold text-zinc-400">FR</button>
              </div>
            </div>
          </div>

          {/* Toolbar */}
          <div className="px-4 py-2.5 border-b border-zinc-800/60 bg-zinc-950/95 sticky top-0">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-zinc-500" />
              <input
                disabled
                placeholder="Search: match, block..."
                className="w-full bg-zinc-900 border border-zinc-800 rounded-full pl-9 pr-3 py-2 text-xs text-zinc-300 placeholder-zinc-600"
              />
            </div>
            <div className="flex gap-1.5 mt-2 overflow-x-auto pb-0.5 -mx-1 px-1" style={{ scrollbarWidth: 'none' }}>
              <button className="shrink-0 px-2.5 py-1 text-[11px] font-semibold rounded-full bg-zinc-900 border border-zinc-800 text-zinc-300 flex items-center gap-1">
                Matches <ChevronDown className="h-3 w-3" />
              </button>
              <button className="shrink-0 px-2.5 py-1 text-[11px] font-semibold rounded-full bg-zinc-900 border border-zinc-800 text-zinc-300 flex items-center gap-1">
                Categories <ChevronDown className="h-3 w-3" />
              </button>
            </div>
          </div>

          {/* CONTENU */}
          <div className="px-3 py-3 space-y-2.5">
            {/* === Match 1 — pas de niveau "Category", tout est inline === */}
            <div className="bg-zinc-900/90 border border-zinc-700 rounded-2xl overflow-hidden ring-1 ring-white/5">
              <div className="p-3.5">
                <div className="flex items-center gap-2">
                  <ChevronDown className="h-4 w-4 text-amber-400 shrink-0" />
                  <div className="text-sm font-bold text-white leading-tight flex-1 min-w-0">M6 AUSTRALIA VS TURKEY</div>
                  <div className="flex items-center gap-1 shrink-0">
                    <img src="https://flagcdn.com/au.svg" alt="" className="h-5 w-7 rounded object-cover" />
                    <img src="https://flagcdn.com/tr.svg" alt="" className="h-5 w-7 rounded object-cover" />
                  </div>
                </div>
                <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-zinc-400 pl-6">
                  <span className="px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-300 border border-amber-500/30 font-bold uppercase tracking-wider text-[9px]">GROUP D</span>
                  <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />Sat, Jun 13 · <span className="text-amber-400/80 font-semibold">21:00</span></span>
                </div>
                <div className="mt-1 flex items-center gap-1 text-[11px] text-zinc-500 pl-6">
                  <MapPin className="h-3 w-3 shrink-0" />
                  <span className="truncate">BC Place Stadium — Vancouver</span>
                </div>
              </div>

              {/* Liste DIRECTE des lots — ordonnés CAT 1 → CAT 4 puis SUP 1 → SUP N
                  Couleurs officielles FIFA : CAT 1 orange, CAT 2 rouge, CAT 3 bleu, CAT 4 vert */}
              <div className="border-t border-zinc-800/60 px-3.5 py-3 space-y-1.5">
                {/* CAT 1 - orange (FIFA) */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-orange-500/20 text-orange-300 border border-orange-500/40 whitespace-nowrap">CAT 1</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 101 · Row 4</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 2
                  </span>
                </div>
                {/* CAT 2 - rouge (FIFA) */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-red-500/20 text-red-300 border border-red-500/40 whitespace-nowrap">CAT 2</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 105 · Row 22</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 2
                  </span>
                </div>
                {/* CAT 3 - bleu (FIFA) */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-500/20 text-blue-300 border border-blue-500/40 whitespace-nowrap">CAT 3</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 188 · Row 12</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 4
                  </span>
                </div>
                {/* CAT 4 - vert (FIFA) */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-green-600/20 text-green-300 border border-green-600/40 whitespace-nowrap">CAT 4</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 233 · Row 36</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 4
                  </span>
                </div>
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-green-600/20 text-green-300 border border-green-600/40 whitespace-nowrap">CAT 4</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 217 · Row 38</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 4
                  </span>
                </div>
                {/* SUP 1 - violet (catégories supporters / fan packs) */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-500/20 text-purple-300 border border-purple-500/40 whitespace-nowrap">SUP 1</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 320 · Row 2</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 2
                  </span>
                </div>
                {/* SUP 2 - rose */}
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-pink-500/20 text-pink-300 border border-pink-500/40 whitespace-nowrap">SUP 2</span>
                    <span className="text-[13px] font-mono text-zinc-400 italic truncate">No location</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 4
                  </span>
                </div>
              </div>
            </div>

            {/* === Match 2 === */}
            <div className="bg-zinc-900/90 border border-zinc-700 rounded-2xl overflow-hidden ring-1 ring-white/5">
              <div className="p-3.5">
                <div className="flex items-center gap-2">
                  <ChevronDown className="h-4 w-4 text-amber-400 shrink-0" />
                  <div className="text-sm font-bold text-white leading-tight flex-1 min-w-0">M33 GERMANY VS IVORY COAST</div>
                  <div className="flex items-center gap-1 shrink-0">
                    <img src="https://flagcdn.com/de.svg" alt="" className="h-5 w-7 rounded object-cover" />
                    <img src="https://flagcdn.com/ci.svg" alt="" className="h-5 w-7 rounded object-cover" />
                  </div>
                </div>
                <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-zinc-400 pl-6">
                  <span className="px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-300 border border-amber-500/30 font-bold uppercase tracking-wider text-[9px]">GROUP E</span>
                  <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />Sat, Jun 20 · <span className="text-amber-400/80 font-semibold">16:00</span></span>
                </div>
                <div className="mt-1 flex items-center gap-1 text-[11px] text-zinc-500 pl-6">
                  <MapPin className="h-3 w-3 shrink-0" />
                  <span className="truncate">BMO Field — Toronto</span>
                </div>
              </div>
              <div className="border-t border-zinc-800/60 px-3.5 py-3 space-y-1.5">
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-500/15 text-purple-300 border border-purple-500/30 whitespace-nowrap">CAT 2</span>
                    <span className="text-[13px] font-mono text-amber-300 font-bold truncate">Block 102 · Row 12</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 4
                  </span>
                </div>
                <div className="bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 flex items-center justify-between gap-2">
                  <div className="flex items-center gap-1.5 min-w-0 flex-1">
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-500/15 text-purple-300 border border-purple-500/30 whitespace-nowrap">CAT 2</span>
                    <span className="text-[13px] font-mono text-zinc-400 italic truncate">No location</span>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/20 text-emerald-300 border border-emerald-500/40 whitespace-nowrap">
                    Pack 8
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-zinc-800 mt-2 py-3 text-center text-[10px] text-zinc-600">
            Powered by YAS · Live updates
          </div>
        </div>

        <div className="h-7 flex items-center justify-center">
          <div className="bg-zinc-700 rounded-full w-32 h-1" />
        </div>
      </div>
    </div>
  );
};

export default MobileMockupDemo;
